import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAccount } from 'wagmi';

interface RequireWalletProps {
  children: React.ReactNode;
}

export function RequireWallet({ children }: RequireWalletProps) {
  const { t } = useTranslation('common');
  const { isConnected, isReconnecting } = useAccount();

  if (isReconnecting) {
    return (
      <div className="flex min-h-[12rem] items-center justify-center">
        <p className="text-sm text-muted-foreground">{t('wallet.reconnecting')}</p>
      </div>
    );
  }

  if (!isConnected) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
